import * as tslib_1 from "tslib";
import setCalendarProcessingOptions from '../services/setCalendarProcessingOptions';
import initializeCalendarProcessingOptions from '../actions/initializeCalendarProcessingOptions';
/**
 * Trigger a service call to set calendar processing options and mutate the store
 */
export default function saveCalendarProcessingOptions(calendarProcessingOptions) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, setCalendarProcessingOptions(calendarProcessingOptions)];
                case 1:
                    _a.sent();
                    initializeCalendarProcessingOptions(calendarProcessingOptions);
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=saveCalendarProcessingOptions.js.map